import { render, staticRenderFns } from "./wxxiangqingUpdate.vue?vue&type=template&id=792440d6&scoped=true"
import script from "./wxxiangqingUpdate.vue?vue&type=script&lang=js"
export * from "./wxxiangqingUpdate.vue?vue&type=script&lang=js"
import style0 from "./wxxiangqingUpdate.vue?vue&type=style&index=0&id=792440d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792440d6",
  null
  
)

export default component.exports